import { render, staticRenderFns } from "./DialogNodeContentTreeLight.vue?vue&type=template&id=b3848898&scoped=true"
import script from "./DialogNodeContentTreeLight.vue?vue&type=script&lang=js"
export * from "./DialogNodeContentTreeLight.vue?vue&type=script&lang=js"
import style0 from "./DialogNodeContentTreeLight.vue?vue&type=style&index=0&id=b3848898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3848898",
  null
  
)

export default component.exports